import React from "react";
import { Grid, MenuItem } from "@mui/material";
import { useCateringStore } from "../../../../../store/useCateringStore";
import Input from "../../../../../components/Input";
import {
  OperationsDetailField,
  OperationsDetailGrid,
} from "../../../ifas/components/OperationsUI";

export default function ClaimantAndDeceased({
  isEditable = false,
}: {
  isEditable?: boolean;
}) {
  const { selectedCatering, setCateringBasicInfo } = useCateringStore();
  const item = selectedCatering?.basicInfo;

  const handleChange =
    (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setCateringBasicInfo({
        [field]: event.target.value,
      } as any);
    };

  if (!isEditable) {
    return (
      <OperationsDetailGrid>
        <OperationsDetailField
          label="Claimant Full Name"
          value={item?.claimantFullName}
        />
        <OperationsDetailField
          label="Contact Number"
          value={item?.claimantContactNumber}
        />
        <OperationsDetailField label="Email" value={item?.claimantEmail} />
        <OperationsDetailField
          label="Deceased Full Name"
          value={item?.deceasedFullName}
        />
        <OperationsDetailField label="Funeral Date" value={item?.funeralDate} />
        <OperationsDetailField label="Service Type" value={item?.serviceType} />
        <OperationsDetailField
          label="Supplementary Name"
          value={item?.supplementaryName}
        />
        <OperationsDetailField
          label="Cash Benefit Value"
          value={item?.cashBenefitValue}
        />
        <OperationsDetailField
          label="Service Benefit Value"
          value={item?.serviceBenefitValue}
        />
      </OperationsDetailGrid>
    );
  }

  return (
    <Grid container rowSpacing={5} columnSpacing={10} mt={1} textAlign="left" p={3}>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          value={item?.claimantFullName || ""}
          onChange={handleChange("claimantFullName")}
          height={40}
          width="100%"
          label="Claimant Full Name"
          backgroundColor="background.paper"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          value={item?.claimantContactNumber || ""}
          onChange={handleChange("claimantContactNumber")}
          height={40}
          width="100%"
          label="Contact Number"
          backgroundColor="background.paper"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          value={item?.claimantEmail || ""}
          onChange={handleChange("claimantEmail")}
          height={40}
          width="100%"
          label="Email"
          backgroundColor="background.paper"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          value={item?.deceasedFullName || ""}
          onChange={handleChange("deceasedFullName")}
          height={40}
          width="100%"
          label="Deceased Full Name"
          backgroundColor="background.paper"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          type="date"
          value={item?.funeralDate || ""}
          onChange={handleChange("funeralDate")}
          height={40}
          width="100%"
          label="Funeral Date"
          backgroundColor="background.paper"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          select
          value={item?.serviceType || ""}
          onChange={handleChange("serviceType")}
          height={40}
          width="100%"
          label="Service Type"
          backgroundColor="background.paper"
        >
          <MenuItem value="Full Service">Full Service</MenuItem>
          <MenuItem value="Catering Only">Catering Only</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </Input>
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          value={item?.supplementaryName || ""}
          onChange={handleChange("supplementaryName")}
          height={40}
          width="100%"
          label="Supplementary Name"
          backgroundColor="background.paper"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          value={item?.cashBenefitValue || ""}
          onChange={handleChange("cashBenefitValue")}
          height={40}
          width="100%"
          label="Cash Benefit Value"
          backgroundColor="background.paper"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          value={item?.serviceBenefitValue || ""}
          onChange={handleChange("serviceBenefitValue")}
          height={40}
          width="100%"
          label="Service Benefit Value"
          backgroundColor="background.paper"
        />
      </Grid>
    </Grid>
  );
}
